import React from 'react'

function InfoQuienesSomos() {
  return (
    <>
        <hr className='linea'
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1500" />

        <h1 className='text-center text-uppercase titulo'
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1500">Quiénes somos</h1>

        <p className='justify-content text-uppercase infoqs mt-5'
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1500">
            Somos una carrera en donde se abordan las bases teóricas y metodológicas necesarias para el diseño,
            implantación, análisis, control, procesamiento, transporte, operatividad, toma de decisiones y búsqueda de seguridad
            de los sistemas informáticos.
            <br />
            Nuestro enfoque está en estudiar el desarrollo de sistemas automatizados y el uso de los lenguajes de programación;
            de igual forma se enfoca al análisis, diseño y la utilización del hardware y software para lograr la implementación
            de las más avanzadas aplicaciones industriales y telemáticas.
        </p>

        <hr className='linea'
            data-aos="fade-up"
            data-aos-easing="linear"
            data-aos-duration="1500"
        />
    </>
  )
}

export default InfoQuienesSomos
